import {
  ExportCallRecordsRequest,
  PhoneRecordsAPI,
} from '@weave/schema-gen-ts/dist/schemas/phone-exp/phone-records/v1/phone_records_api.pb';
import { DemoInterceptorUtils, FeatureMockRouter } from '@frontend/demo-interceptors';
import { BaseMockRouterContext } from './types';

export type CsvDownloadMockRouterContext = BaseMockRouterContext;

export const CsvDownloadMockRouter: FeatureMockRouter<CsvDownloadMockRouterContext> = {
  getRequestInterceptors: ({ interceptorIdPrefix, vertical, locationId, getScopeName }) => {
    return [
      {
        id: `${interceptorIdPrefix}-export-call-records`,
        interceptor: async (request) => {
          const isMatching = await DemoInterceptorUtils.isMatchingApiEndpoint({
            schemaMethod: PhoneRecordsAPI.ExportCallRecords,
            requestUrl: request.url,
            method: request.method,
          });
          if (isMatching) {
            const requestBody: ExportCallRecordsRequest = await request.clone().json();
            requestBody.isDemo = true;
            requestBody.demoMetadata = {
              vertical,
              locationName: getScopeName(requestBody.locationIds[0] ?? locationId) || 'Demo Location',
            };

            return new Request(request, {
              body: JSON.stringify(requestBody),
            });
          }

          return request;
        },
      },
    ];
  },
};
